import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MediaType } from "app/shared/helpers/media-type.helper";
import { MaestroTags } from "app/shared/models";
import { Thumb } from "app/shared/models/thumb";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { environment } from "src/environments";
import { TagService } from "../tag/tag.service";

interface GetThumbParams {
    binImage: any;
}

@Injectable()
export class ThumbnailsService {
    private medias: BehaviorSubject<Thumb[]> = new BehaviorSubject<Thumb[]>([]);
    private elementMedias: BehaviorSubject<Thumb[]> = new BehaviorSubject<Thumb[]>([]);
    media: BehaviorSubject<Thumb> = new BehaviorSubject<Thumb>(null);
    private elementValueMedias: [BehaviorSubject<Thumb[]>] = [new BehaviorSubject<Thumb[]>([])];

    constructor(private _http: HttpClient, private _tagService: TagService, private http: HttpClient) {}

    setMediaParam(mediaParam: Thumb) {
        this.media.next(mediaParam);
    }

    /**
     * Get all media's
     * @returns
     */
    getAll(): Observable<Thumb[]> {
        return this._http.get<Thumb[]>(`${environment.damUrl}/media.json`);
    }

    /**
     * Update a media
     *
     * @param mediaId
     * @param file
     * @param isPicto
     * @returns
     */
    updateMedia(mediaId: number, file: File, isPicto: boolean): Observable<any> {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("picto", isPicto + "");
        return this._http.post(`${environment.damUrl}/upload/${mediaId}.json`, formData);
    }

    getMedias(): Observable<Thumb[]> {
        return this.medias.asObservable();
    }

    getElementOrElementValueMedias(forElement: boolean = true, id: string = null): Observable<Thumb[]> {
        if (forElement) {
            return this.elementMedias.asObservable();
        } else {
            if (!this.elementValueMedias[id]) {
                this.elementValueMedias[id] = new BehaviorSubject<Thumb[]>([]);
            }

            return this.elementValueMedias[id].asObservable();
        }
    }

    /**
     * Fetch medias
     * @returns
     */
    getImages() {
        return this.getAll().subscribe((data: any) => {
            const values = [];
            for (const dataKey of data.data) {
                values.push(new Thumb().deserialize(dataKey));
            }
            this.medias.next(values);
        });
    }

    sendValuesObservables(values, forElement: boolean = true, id: string = null) {
        if (forElement) {
            this.elementMedias.next(values);
        } else {
            this.elementValueMedias[id].next(values);
        }

        this.medias.next(this.medias.value);
    }

    /**
     * Delete a media
     * @param id
     */
    deleteMedia(id: number): Observable<any> {
        return this._http.delete(`${environment.damUrl}/media/${id}.json`);
    }

    getSidebarData(url: string): Observable<MaestroTags> {
        return this._tagService.getSidebarTags(url);
    }

    getDataviewMedias(filter: any): Observable<any> {
        return this._http.post(`${environment.damUrl}/dataview/media.json`, filter);
    }

    /**
     * Get the color for display the extension
     * @param extension
     * @returns
     */
    getIconClass(extension: string): string {
        if (MediaType.image.includes(extension.toLowerCase())) {
            return "fas fa-file-image";
        } else if (MediaType.video.includes(extension.toLowerCase())) {
            return "fas fa-file-video";
        } else if (MediaType.audio.includes(extension.toLowerCase())) {
            return "fas fa-file-audio";
        } else if (MediaType.drawing.includes(extension.toLowerCase())) {
            return "fas fa-file-code";
        } else if (MediaType.page.includes(extension.toLowerCase())) {
            return "fas fa-file-alt";
        } else {
            return "fas fa-file";
        }
    }

    /**
     * Get the base64 image
     * @param param0
     * @returns
     */
    public getThumb({ binImage }: GetThumbParams) {
        let img =
            "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";

        if (binImage) {
            img = binImage;
        }

        return "data:image/jpeg;base64," + img;
        //return this.sanitizer.bypassSecurityTrustUrl(`data:image/jpeg;base64,${img}`);
    }

    setDefaultImage(event) {
        event.target.src = environment.damUrl + "/default/default.png";
    }

    getUrlMetadata(link: string): Observable<{ thumbPath; name }> {
        let data = { thumbPath: "", name: "" };
        let subject = new Subject<{ thumbPath; name }>();

        if (link.length) {
            this.http
                .get(link, {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods": "GET",
                        "Access-Control-Allow-Headers": "*",
                        "Content-Type": "application/json",
                        "Content-Maestro": "external-link",
                    },
                })
                .subscribe((res: any) => {
                    const metadata = Array.isArray(res) ? res[0] : res;

                    if (metadata.hasOwnProperty("image")) {
                        data.thumbPath = metadata.image;
                    } else if (metadata.hasOwnProperty("thumbnailUrl")) {
                        data.thumbPath = metadata.thumbnailUrl;
                    } else if (metadata.hasOwnProperty("url")) {
                        data.thumbPath = metadata.url;
                    }

                    if (metadata.hasOwnProperty("title")) {
                        data.name = metadata.title;
                    } else if (metadata.hasOwnProperty("name")) {
                        data.name = metadata.name;
                    }

                    subject.next(data);
                });
        } else {
            subject.next(data);
        }

        return subject.asObservable();
    }
}
